import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "v-application" }, [
    _c(
      "div",
      {
        staticClass: "y-doc-review-award-banner",
        class: { "w-100": _setup.isMobile },
      },
      [
        _c("div", { staticClass: "text-subtitle-1 mb-4" }, [
          _vm._v("\n      " + _vm._s(_setup.title) + "\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c(
              VBtn,
              {
                staticClass: "mr-3",
                attrs: {
                  color: "secondary",
                  "data-google-goal": "click_leave_review_pay",
                  href: _vm.reviewLink,
                  depressed: "",
                },
              },
              [
                _c("span", { staticClass: "bg-gray-0--text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _setup.t("Оставить отзыв", { ns: _setup.language })
                      ) +
                      "\n        "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              VBtn,
              {
                attrs: {
                  color: "text",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  href: _setup.fileReviewProgramm,
                  text: "",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_setup.t("Подробнее", { ns: _setup.language })) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }